import React, { useContext, useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import { FaSearch } from 'react-icons/fa'
import { FiCheck } from 'react-icons/fi'
import { toast } from 'react-toastify'

import { Container } from './styles'
import Card from '../../../../components/Card'
import { api, authHeaders } from '../../../../services/api'
import Table from '../../../../components/Table'
import Modal from '../../../../components/Modal'
import { Button, Select, Textbox } from '../../../../components/Form'
import formUtils from '../../../../util/form'
import { GlobalContext } from '../../../../contexts/GlobalContext'
import { frCA } from 'date-fns/locale'

export default function () {
	const { checkException } = useContext(GlobalContext)

	const [faculdadesCadastradas, setFaculdadesCadastradas] = useState(null)
	const [instituicoesAValidar, setInstituicoesAValidar] = useState(null)
	const [instituicaoAValidar, setInstituicaoAValidar] = useState(null)

	async function loadInstituicoes() {
		const response = await api.get('faculdades_a_validar', authHeaders())

		setInstituicoesAValidar(response)
	}

	async function loadInstituicoesCadastradas() {
		const response = await api.get('faculdade')

		setFaculdadesCadastradas(response)
	}

	async function handleValidar(values) {
		try {
			values = formUtils.extractFormValues(values)

			await api.post(`faculdade/validar/${instituicaoAValidar.id}`, values, authHeaders())

			toast.success('Instituição validada!')

			setInstituicaoAValidar(null)
		} catch(e) {
			checkException(e)
		}
	}

	async function handleVincularInstituicao(values) {
		try {
			values = formUtils.extractFormValues(values)

			await api.post(`faculdade/validar/${instituicaoAValidar.id}`, values, authHeaders())

			toast.success('Instituição vinculada!')

			setInstituicaoAValidar(null)
		} catch(e) {
			checkException(e)
		}
	}

	useEffect(() => {
		loadInstituicoes()

		loadInstituicoesCadastradas()
	}, [])

	if (!instituicoesAValidar) {
		return null
	}

	return (
		<>
			<Container>
				<Card>
					<h1>Validar instituições</h1>

					<Table
						headers={[
							{ name: 'descricao', value: 'Nome' },
							{ name: 'local', value: 'UF / cidade' }
						]}
						data={instituicoesAValidar}
						actions={[
							{
								action: setInstituicaoAValidar,
								name: 'Analisar',
								icon: FaSearch,
								iconSize: 16
							}
						]}
					/>
				</Card>
			</Container>

			<Modal
				isOpen={!!instituicaoAValidar}
				handleClose={() => {
					setInstituicaoAValidar(null)
				}}
				title="Validar instituição"
			>
				{instituicaoAValidar ? (
					<div className="flex flex-col mx-2 mt-4 gap-2">
						<p>Nome da instituição: {instituicaoAValidar.descricao}</p>
						<p>Local: {instituicaoAValidar.local}</p>
						<p>Pessoa: {instituicaoAValidar.pessoa.nome}</p>

						<div className="flex gap-8 w-full mt-4">
							<Formik
								onSubmit={handleValidar}
								initialValues={{
									descricao: '',
									sigla: '',
									uf: '',
									cidade: '',
									categoria: ''
								}}
							>
								{({ setFieldValue }) => (
									<Form className="flex flex-col w-full">
										<h2 className="font-bold" style={{ fontSize: 16 }}>Cadastrar nova instituição</h2>

										<Textbox
											name="descricao"
											label="Descrição"
										/>

										<Textbox
											name="sigla"
											label="Sigla"
										/>

										<Textbox
											name="uf"
											label="UF"
										/>

										<Textbox
											name="cidade"
											label="Cidade"
										/>

										<Select
											name="categoria"
											label="Categoria"
											onChange={(selected, meta) => {
												setFieldValue(meta.name, selected)
											}}
											options={[
												{ value: 'PÚBLICA', label: 'Pública' },
												{ value: 'PRIVADA', label: 'Privada' }
											]}
										/>

										<Button type="submit" className="white self-end">
											Confirmar
											<FiCheck size={16} />
										</Button>
									</Form>
								)}
							</Formik>

							<Formik
								onSubmit={handleVincularInstituicao}
								initialValues={{
									instituicao: ''
								}}
							>
								{({ setFieldValue }) => (
									<Form className="w-full flex flex-col">
										<h2 className="font-bold" style={{ fontSize: 16 }}>Vincular instituição já existente</h2>

										<Select
											name="instituicao"
											label="Instituição de ensino"
											onChange={(selected, meta) => {
												setFieldValue(meta.name, selected)
											}}
											options={faculdadesCadastradas.map(fac => ({
												label: fac.descricao,
												value: fac.id
											}))}
										/>

										<Button type="submit" className="white self-end">
											Confirmar
											<FiCheck size={16} />
										</Button>
									</Form>
								)}
							</Formik>
						</div>
					</div>
				) : <div></div>}
			</Modal>
		</>
	)
}
